/* Search fields: header overlay and results page.
   - Panels: Popular searches + Quick links while empty; suggestions, products (same order as the results page,
     via the pbs-search-hits section) and collections while typing. Show more adds the next 6 to 8 products in
     place (sections/pbs-search-more, deduplicated), with a "Showing N of M" count and a See all results link.
   - Searches hold at most 80 characters (typed or dictated); reaching it shows "Character limit reached".
   - Clear button, voice dictation pill (live bars, cancel, finish). Dictation keeps listening through pauses and
     restarts itself after the browser ends a session or reports no-speech / network, building on the words so far;
     it stops only on the tick, the cancel button, Escape, closing search or the character limit.
   - Overlay position on the top bar row, outside tap to close. The page lock and frost are CSS on html.pbs-open,
     so every close path releases them. */
(function () {
  if (window.pbSearch) return;
  var root = document.documentElement;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var MOBILE = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {};
  var LIMIT_MSG = 'Character limit reached';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mark(text, q) {
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return esc(text);
    return esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + q.length)) + '</b>' + esc(text.slice(i + q.length));
  }
  function searchUrl(q) { return R + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function hitsUrl(q, sec, page) { return searchUrl(q) + '&type=product' + (page ? '&page=' + page : '') + '&section_id=' + sec; }
  function hitKey(a) { try { return new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return a.getAttribute('href'); } }

  function setup(input) {
    if (input.dataset.pbsReady) return;
    input.dataset.pbsReady = '1';
    var form = input.closest('form'); if (!form) return;
    form.classList.add('pbs-form');
    var overlay = !!form.closest('#FormSearch');
    var $ = function (s) { return form.querySelector(s); };
    var clearBtn = $('.pbs-clear'), mic = $('.pbs-mic'), pill = $('.pbs-voice'), msg = $('.pbs-msg');
    var shell = $('[data-pbs-shell]'), pDef = $('[data-pbs-default]'), pRes = $('[data-pbs-results]'), pFind = $('[data-pbs-fit]');
    var mode = 'search', findT = 0, findSeq = 0, fitOn = false;
    var terms = [].map.call(form.querySelectorAll('[data-pbs-term]'), function (a) { return { t: a.getAttribute('data-pbs-term'), u: a.getAttribute('href') }; });
    var timer = 0, ctl = null, lastQ = null, focused = false, msgT = 0;
    /* 80 characters for Search, 200 for Find a bag for me (needs read as sentences) */
    function lim() { return mode === 'find' ? 200 : 80; }
    input.maxLength = 80;
    /* the overlay field is a one-row textarea that grows to three lines, then scrolls inside (newest words in view);
       a mirror measures the height so the change can ease; Enter submits, as the keyboard's search key */
    var TA = input.tagName === 'TEXTAREA', mirror = null;
    function grow() {
      if (!TA) return;
      if (/\n/.test(input.value)) input.value = input.value.replace(/\s*\n+\s*/g, ' ');
      var cs = getComputedStyle(input);
      if (!mirror) { mirror = input.cloneNode(false); mirror.removeAttribute('id'); mirror.removeAttribute('name'); mirror.removeAttribute('x-data'); mirror.removeAttribute('data-pbs-field'); mirror.removeAttribute('autofocus'); mirror.setAttribute('aria-hidden', 'true'); mirror.tabIndex = -1;
        mirror.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:0;min-height:0;top:0;left:0;transition:none;overflow:hidden;'; input.parentNode.appendChild(mirror); }
      mirror.style.width = input.offsetWidth + 'px';
      mirror.style.padding = cs.padding; mirror.style.font = cs.font; mirror.style.lineHeight = cs.lineHeight; mirror.style.letterSpacing = cs.letterSpacing; mirror.style.borderWidth = cs.borderWidth; mirror.style.boxSizing = cs.boxSizing;
      mirror.value = input.value || input.getAttribute('placeholder') || '';
      if (!input.value) mirror.value = 'x';
      var lh = parseFloat(cs.lineHeight) || 22, pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom), bd = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
      var one = Math.round(lh + pad + bd), max = Math.round(lh * 3 + pad + bd);
      var want = Math.round(mirror.scrollHeight + bd);
      var h = Math.max(one, Math.min(max, want));
      input.style.height = h + 'px';
      input.style.overflowY = want > max + 1 ? 'auto' : 'hidden';
      form.classList.toggle('pbs-multi', h > one + 2);
      root.style.setProperty('--pbs-fh', h + 'px');
    }
    if (TA) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
          e.preventDefault();
          var sb = form.querySelector('button[type="submit"], .btn-search');   /* a real submit, so every submit listener runs */
          if (sb) sb.click(); else form.submit();
        }
      });
      window.addEventListener('resize', grow, { passive: true });
      /* the first measure reads layout: run it once the page is idle and not scrolling (the field is sized again whenever it opens) */
      if (window.pbWhenIdle) window.pbWhenIdle(grow); else setTimeout(grow, 0);
    }
    var M = null; /* Show more state for the current query */

    function q() { return input.value.trim(); }
    function panelsVisible() { return overlay ? root.classList.contains('pbs-open') : focused; }
    function show() {
      var has = q() !== '';
      form.classList.toggle('pbs-has-text', input.value !== '');
      if (clearBtn) clearBtn.hidden = input.value === '' || form.classList.contains('pbs-listening');
      /* one shell stays up while the overlay is open; only its parts change (no hide-and-show of the panel) */
      var vis = panelsVisible(), find = mode === 'find' && pFind;
      if (vis && TA && !input.style.height) grow();
      if (mode === 'find' && typeof ghostUpd === 'function') ghostUpd();
      if (shell) shell.hidden = !vis;
      if (pFind) pFind.hidden = !(find || (fitOn && has));
      if (pDef) pDef.hidden = !!find || (has && lastQ !== null);
      if (pRes) pRes.hidden = !!find || !has || lastQ === null;
    }
    function say(text) {
      if (!msg) return;
      clearTimeout(msgT); msg.textContent = text; msg.hidden = !text;
      if (text) msgT = setTimeout(function () { msg.hidden = true; }, 6000);
    }

    /* results */
    function render(qq, hitsHtml, sugg) {
      if (qq !== q()) return;
      lastQ = qq;
      var doc = new DOMParser().parseFromString(hitsHtml || '', 'text/html');
      var hits = doc.querySelector('.pbs-hits');
      var list = hits && hits.querySelector('.pbs-hits__list');
      var count = hits ? parseInt(hits.getAttribute('data-pbs-count') || '0', 10) : 0;
      var tpl = hits && hits.querySelector('.pbs-hits__titles');
      var titles = tpl ? (tpl.innerHTML || '').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').split('||') : [];
      var low = qq.toLowerCase(), seen = {}, items = [];
      function add(text, url) {
        text = (text || '').trim(); var k = text.toLowerCase();
        if (!text || seen[k] || items.length >= 6) return; seen[k] = 1; items.push({ t: text, u: url || searchUrl(text) });
      }
      terms.filter(function (x) { return x.t.toLowerCase().indexOf(low) === 0; }).forEach(function (x) { add(x.t, x.u); });
      terms.filter(function (x) { return x.t.toLowerCase().indexOf(low) > 0; }).forEach(function (x) { if (items.length < 3) add(x.t, x.u); });
      ((sugg && sugg.queries) || []).forEach(function (x) { if (items.length < 4) add(x.text); });
      titles.forEach(function (t) { if (items.length < 6) add(t.toLowerCase()); });
      var sw = $('[data-pbs-sugg-wrap]'), sl = $('[data-pbs-sugg]');
      sl.innerHTML = items.map(function (x) { return '<li><a href="' + esc(x.u) + '"><span>' + mark(x.t, qq) + '</span></a></li>'; }).join('');
      sw.hidden = !items.length;
      var pw = $('[data-pbs-prod-wrap]'), pp = $('[data-pbs-prod]');
      pp.innerHTML = list && list.children.length ? list.outerHTML : '';
      pw.hidden = !pp.innerHTML;
      var cw = $('[data-pbs-coll-wrap]'), cl = $('[data-pbs-coll]');
      var colls = ((sugg && sugg.collections) || []).slice(0, 4);
      cl.innerHTML = colls.map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('');
      cw.hidden = !colls.length;
      var empty = $('[data-pbs-empty]'), all = $('[data-pbs-all]');
      var none = !items.length && !pp.innerHTML && !colls.length;
      empty.hidden = !none; empty.textContent = none ? 'No results for “' + qq + '”. Try a shorter word or a popular search.' : '';
      if (all) all.href = searchUrl(qq);
      var ul = pp.querySelector('.pbs-hits__list'), seen = {};
      if (ul) [].forEach.call(ul.querySelectorAll('[data-pbs-url]'), function (li) { seen[li.getAttribute('data-pbs-url')] = 1; });
      M = { q: qq, ul: ul, total: count, n: ul ? ul.children.length : 0, seen: seen, page: 0, pages: Infinity, queue: [], busy: false };
      moreUi();
      show();
    }
    /* Show more: pull 8-per-page batches, drop rows already shown, add up to 8 at a time */
    var moreWrap = $('[data-pbs-more-wrap]'), moreBtn = $('[data-pbs-more]'), countEl = $('[data-pbs-count]');
    function moreLeft() { return M && M.ul && (M.queue.length > 0 || (M.page < M.pages && M.n < M.total)); }
    function moreUi() {
      if (!moreWrap) return;
      if (!M || !M.ul || !M.n) { moreWrap.hidden = true; return; }
      moreWrap.hidden = false;
      var left = moreLeft();
      if (!left) M.total = M.n;
      countEl.textContent = left ? 'Showing ' + M.n + ' of ' + M.total : (M.n === 1 ? 'Showing the only result' : 'Showing all ' + M.n);
      moreBtn.hidden = !left;
      moreBtn.disabled = !!M.busy; moreBtn.textContent = M.busy ? 'Loading…' : 'Show more';
    }
    function addBatch(m) {
      var take = m.queue.splice(0, 8), first = null;
      take.forEach(function (li) { li.classList.add('pbs-in'); m.ul.appendChild(li); m.n++; if (!first) first = li; });
      m.busy = false; moreUi();
      if (first && shell) {
        var pr = shell.getBoundingClientRect(), fr = first.getBoundingClientRect();
        if (fr.top > pr.bottom - 60) {
          var to = shell.scrollTop + (fr.top - pr.top) - 72;
          try { shell.scrollTo({ top: to, behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) { shell.scrollTop = to; }
        }
      }
    }
    function loadMore() {
      var m = M; if (!m || m.busy || !moreLeft()) return;
      m.busy = true; moreUi();
      (function pull() {
        if (m !== M) return;
        if (m.queue.length >= 8 || m.page >= m.pages || m.n + m.queue.length >= m.total) { addBatch(m); return; }
        m.page++;
        fetch(hitsUrl(m.q, 'pbs-search-more', m.page)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          if (m !== M) return;
          var d = new DOMParser().parseFromString(html, 'text/html'), l = d.querySelector('.pbs-hits__list');
          if (!l) { m.pages = m.page; pull(); return; }
          m.pages = parseInt(l.getAttribute('data-pbs-pages') || '0', 10) || m.page;
          [].forEach.call(l.children, function (li) {
            var k = li.getAttribute('data-pbs-url'); if (!k) return;
            if (m.seen[k]) return; m.seen[k] = 1;
            m.queue.push(document.importNode(li, true));
          });
          pull();
        }).catch(function () { m.busy = false; moreUi(); });
      })();
    }
    if (moreBtn) moreBtn.addEventListener('click', function (e) { e.preventDefault(); loadMore(); });
    function fetchQ(qq) {
      if (cache[qq]) { render(qq, cache[qq][0], cache[qq][1]); return; }
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var o = ctl ? { signal: ctl.signal } : {};
      var a = fetch(hitsUrl(qq, 'pbs-search-hits'), o).then(function (r) { return r.ok ? r.text() : ''; });
      var b = fetch(R + 'search/suggest.json?q=' + encodeURIComponent(qq) + '&resources%5Btype%5D=query,collection&resources%5Blimit%5D=6', o)
        .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return j && j.resources && j.resources.results; }).catch(function () { return null; });
      Promise.all([a, b]).then(function (v) { cache[qq] = v; render(qq, v[0], v[1]); }).catch(function () {});
    }
    /* Find a bag for me (assets/pb-bagfind.js): in that mode every text is read as needs; in Search mode a text that reads
       like a need ("a backpack for my 16 inch laptop") also gets "Bags that fit you" above the product results */
    var PH = { search: 'Search, or describe what you need', find: '' };   /* Find mode shows a cycling example as ghost text instead */
    var EX = ['A backpack for my 16″ laptop and a Switch', 'A tote for work and A4 notebooks', 'Something small for a night out', 'Shows off lots of pins', 'Holds my water bottle and a camera', 'Room for shoes and gym clothes'];
    var PHS = { search: 'Search or describe your needs', find: '' };   /* phones: whole words, no cut-off */
    function holdPlaceholder(m) {
      var tt = (window.innerWidth < 750 ? PHS : PH)[m], t = tt == null ? PH.search : tt;
      try { Object.defineProperty(input, 'placeholder', { configurable: true, get: function () { return t; }, set: function () {} }); } catch (e) {}
      input.setAttribute('placeholder', t);
    }
    if (pFind) holdPlaceholder('search');
    window.addEventListener('resize', function () { if (pFind) holdPlaceholder(mode); }, { passive: true });
    /* phones: the Search / Find a bag for me toggle sits above the field (on the header row's line), outside the
       scrolling panel; desktop keeps it at the top of the panel. Moved once per breakpoint change, never re-mounted. */
    var modesEl = form.querySelector('.pbs-modes');
    function placeModes() {
      if (!modesEl || !overlay || !shell) return;
      var phone = window.innerWidth < 750;
      if (phone && modesEl.parentNode !== form) { form.insertBefore(modesEl, form.firstChild); modesEl.classList.add('pbs-modes--top'); }
      else if (!phone && modesEl.parentNode !== shell) { shell.insertBefore(modesEl, shell.firstChild); modesEl.classList.remove('pbs-modes--top'); }
    }
    placeModes();
    window.addEventListener('resize', placeModes, { passive: true });
    var NEED = /(\b\d{2}(\.\d)?\s*("|″|”|-?\s?inch|in\b))|\b(laptop|macbook|ipad|tablet|nintendo|steam ?deck|console|a4|documents?|folders?|water ?bottle|camera|clothes|gym|commute|school|uni|work|travel|trip|for my|for a|to carry|carry|fits?|fitting|wear|worn|across the body|over the shoulder|need)\b/i;
    function looksLikeNeed(t) { return t.split(/\s+/).length >= 3 && NEED.test(t); }
    function bagFinder() {
      if (window.pbBagFind) return Promise.resolve(window.pbBagFind);
      return new Promise(function (res, rej) {
        /* the panel carries the versioned asset URL, so a new pb-bagfind.js is never served from an old cache key */
        var src = (shell && shell.getAttribute('data-pbs-bagfind')) || ((document.querySelector('script[src*="pb-search.js"]') || {}).src || '').replace(/pb-search\.js/, 'pb-bagfind.js');
        var sc = document.createElement('script'); sc.src = src; sc.async = true;
        sc.onload = function () { window.pbBagFind ? res(window.pbBagFind) : rej(); }; sc.onerror = rej; document.head.appendChild(sc);
      });
    }
    /* bag photos at thumbnail size (Shopify CDN width), fetched once into a cache as soon as the bag list loads */
    function thumb(u) { u = String(u || ''); if (!u) return ''; return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1160') : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=160'; }
    var thumbsWarm = false;
    function warmThumbs() {
      if (thumbsWarm) return; thumbsWarm = true;
      bagFinder().then(function (f) { return f.data(); }).then(function (bags) {
        (bags || []).forEach(function (b) { var u = thumb(b.vimg || b.img); if (u) { var im = new Image(); im.decoding = 'async'; im.src = u; } });
      }).catch(function () { thumbsWarm = false; });
    }
    function fitRow(x) {
      var b = x.b, img = thumb(b.vimg || b.img || ''), u = b.url || '#', name = b.spec.name;
      var arw = '<svg class="pbs-act__ic" viewBox="0 0 48 48" width="12" height="12" fill="none" stroke="currentColor" stroke-width="4" aria-hidden="true" focusable="false">';
      return '<li class="pbs-row pbs-in" data-pbs-url="' + esc(u) + '"><a class="pbs-hit__img" href="' + esc(u) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80" loading="eager" decoding="async" fetchpriority="high">' : '') + '</a>' +
        '<span class="pbs-hit__txt"><span class="pbs-hit__top"><span class="pbs-hit__tag">' + esc(x.tag) + '</span>' + (x.pct ? '<span class="pbs-match" title="How well it matches what you told us">' + x.pct + '% match</span>' : '') + '</span>' +
        '<a class="pbs-hit__title" href="' + esc(u) + '">' + esc(name) + '</a>' + (x.why ? '<span class="pbs-hit__why">' + esc(x.why) + '</span>' : '') + '</span>' +
        '<span class="pbs-acts"><button type="button" class="pbs-act" data-pbs-qv="' + esc(u) + '" aria-label="Preview ' + esc(name) + '">Preview' + arw + '<path d="M10 38L37 11"/><path d="M17 11H37V31"/></svg></button>' +
        '<a class="pbs-act pbs-act--go" href="' + esc(u) + '" aria-label="View product: ' + esc(name) + '">View product' + arw + '<path d="M6 24H40"/><path d="M28 12L40 24L28 36"/></svg></a></span></li>';
    }
    function runFind() {
      if (!pFind) return;
      var qq = q(), seq = ++findSeq, auto = mode !== 'find';
      var head = $('[data-pbs-find-h]'), needEl = $('[data-pbs-find-need]'), list = $('[data-pbs-find-list]'), empty = $('[data-pbs-find-empty]');
      var hint = $('[data-pbs-fit-hint]'), quiz = $('[data-pbs-fit-quiz]');
      if (hint) hint.hidden = !auto;
      if (quiz) quiz.hidden = auto;
      if (auto && !looksLikeNeed(qq)) { fitOn = false; show(); return; }
      if (!qq) { head.textContent = 'Tell us what you carry and how you like to wear it'; needEl.hidden = true; list.innerHTML = ''; empty.hidden = true; show(); return; }
      bagFinder().then(function (f) { return f.match(qq); }).then(function (R) {
        if (seq !== findSeq || q() !== qq) return;
        if (auto && !R.bags.length) { fitOn = false; show(); return; }
        fitOn = auto;
        needEl.hidden = !R.need.length; needEl.textContent = R.need.length ? 'Looking for ' + R.need.join(', ') : '';
        head.textContent = 'Bags that fit you';
        var html = R.bags.map(fitRow).join('');
        if (list.getAttribute('data-k') !== html.length + ':' + qq) { list.innerHTML = html; list.setAttribute('data-k', html.length + ':' + qq); }
        empty.hidden = !!R.bags.length; empty.textContent = R.bags.length ? '' : (R.error ? 'The bag list did not load. Try again, or take the full quiz.' : 'Tell us a little more, like your laptop size or how you like to wear it.');
        if (R.bags.length && !auto) rewardShow(); else if (reward && auto) reward.hidden = true;
        show();
      }).catch(function () { if (seq !== findSeq) return; if (auto) { fitOn = false; show(); return; } list.innerHTML = ''; empty.hidden = false; empty.textContent = 'The bag finder did not load. Try the full quiz instead.'; show(); });
    }
    /* suggestion chips under the heading while the Find field is empty; a tap fills the field and matches */
    var fchips = $('[data-pbs-fchips]');
    if (fchips) fchips.innerHTML = EX.map(function (t) { return '<button type="button" class="pbs-fchip" role="listitem" data-pbs-ex="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
    function fillEx(t) { input.value = t.slice(0, lim()); grow(); try { input.focus({ preventScroll: true }); input.setSelectionRange(input.value.length, input.value.length); } catch (e) {} ghostUpd(); changed(); }
    if (fchips) fchips.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-pbs-ex]'); if (b) { e.preventDefault(); fillEx(b.getAttribute('data-pbs-ex')); } });
    /* ghost text: while empty, the current example (cycling); while typing, the rest of an example that starts with the
       words so far. Tab or Right arrow (caret at the end) accepts it; a tap or click on the grey text does too. */
    var ghost = null, gRest = '', exI = 0, exT = 0;
    if (TA && pFind) {
      ghost = document.createElement('div'); ghost.className = 'pbs-ghost'; ghost.hidden = true; ghost.setAttribute('aria-hidden', 'true');
      input.parentNode.insertBefore(ghost, input.nextSibling);
      ghost.addEventListener('pointerdown', function (e) { if (gRest && e.target.closest && e.target.closest('.pbs-ghost__rest, .pbs-ghost__key')) { e.preventDefault(); acceptGhost(); } });
    }
    function ghostUpd() {
      if (!ghost) return;
      var on = mode === 'find' && panelsVisible() && !form.classList.contains('pbs-listening') && input.scrollHeight <= input.clientHeight + 2;
      var v = input.value, rest = '';
      if (on) {
        if (!v) rest = EX[exI % EX.length];
        else if (v.length >= 2) { var lv = v.toLowerCase(); for (var i = 0; i < EX.length; i++) { if (EX[i].toLowerCase().indexOf(lv) === 0 && EX[i].length > v.length) { rest = EX[i].slice(v.length); break; } } }
        try { if (v && input.selectionStart !== v.length) rest = ''; } catch (e) {}
      }
      gRest = rest;
      fchips && (fchips.hidden = !(mode === 'find' && !v));
      if (!rest) { ghost.hidden = true; return; }
      var cs = getComputedStyle(input);
      ghost.style.width = input.offsetWidth + 'px'; ghost.style.height = input.offsetHeight + 'px';
      ghost.style.left = input.offsetLeft + 'px'; ghost.style.top = input.offsetTop + 'px';
      ghost.style.padding = cs.paddingTop + ' ' + cs.paddingRight + ' ' + cs.paddingBottom + ' ' + cs.paddingLeft;
      ghost.style.font = cs.font; ghost.style.lineHeight = cs.lineHeight; ghost.style.letterSpacing = cs.letterSpacing; ghost.style.borderRadius = cs.borderRadius;
      ghost.innerHTML = '<span>' + esc(v) + '</span><span class="pbs-ghost__rest">' + esc(rest) + '</span><span class="pbs-ghost__key">Tab</span>';
      ghost.classList.toggle('is-one', !v);
      ghost.hidden = false;
    }
    function acceptGhost() { if (!gRest) return false; fillEx(input.value + gRest); return true; }
    function cycle() { clearInterval(exT); exT = setInterval(function () { if (mode === 'find' && !input.value && panelsVisible() && !document.hidden) { exI++; ghostUpd(); } }, 3500); }
    if (ghost) {
      input.addEventListener('keydown', function (e) {
        if (!gRest || mode !== 'find') return;
        if ((e.key === 'Tab' && !e.shiftKey) || (e.key === 'ArrowRight' && input.selectionStart === input.value.length)) { e.preventDefault(); acceptGhost(); }
      });
      ['input', 'click', 'keyup', 'focus'].forEach(function (ev) { input.addEventListener(ev, ghostUpd); });
      window.addEventListener('resize', ghostUpd, { passive: true });
    }
    function setMode(m) {
      if (m === mode || !pFind) return;
      mode = m;
      if (reward && m !== 'find') reward.hidden = true;
      [].forEach.call(form.querySelectorAll('.pbs-modes [data-pbs-mode]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pbs-mode') === m ? 'true' : 'false'); });
      holdPlaceholder(m);
      input.maxLength = lim();
      if (m === 'find') { warmThumbs(); cycle(); } else clearInterval(exT);
      setTimeout(ghostUpd, 0);
      fitOn = false;
      if (m === 'find') runFind(); else changed();
      show();
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }
    form.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      /* a product opened from these results: the next add to cart is credited to the search bar (pb-topbar.js) */
      if (t.closest('.pbs-row a, .pbs-row [data-pbs-qv]')) { try { sessionStorage.setItem('pb_src_pending', (window.PBSub && PBSub.SRC && PBSub.SRC.searchBar) || 'src-search-bar'); } catch (x) {} if (window.pbSrcHook) window.pbSrcHook(); }
      var b = t.closest('[data-pbs-mode]'); if (b && form.contains(b)) { e.preventDefault(); setMode(b.getAttribute('data-pbs-mode')); return; }
      /* Preview: the shared quick view over the page; search steps aside first */
      var v = t.closest('[data-pbs-qv]');
      if (v && form.contains(v)) {
        e.preventDefault();
        var href = v.getAttribute('data-pbs-qv');
        if (!window.pbQuickView) { location.href = href; return; }
        if (overlay) { var c = document.getElementById('SearchClose'); if (c && root.classList.contains('pbs-open')) c.click(); }
        setTimeout(function () { try { window.pbQuickView.open(href, null); } catch (x) { location.href = href; } }, overlay ? 60 : 0);
      }
    });
    form.addEventListener('submit', function (e) { if (mode === 'find') { e.preventDefault(); clearTimeout(findT); rewardWanted = true; runFind(); } });

    /* reward card: after a Find a bag for me search, the 5% code waits under invisible ink; an email signs up through the
       hidden customer form (snippets/pb-topbar) and reveals it; people already on the list see it at once */
    var reward = $('[data-pbs-reward]'), rewardWanted = false, rewardInit = false, rewardOpen = false, rewardCodeReady = false;
    function subState() {
      var el = document.querySelector('[data-pb-sub]');
      return {
        code: (window.PBSub && PBSub.code) || (el && el.getAttribute('data-pb-sub-code')) || 'ITSINTHEBAG',
        pct: (window.PBSub && PBSub.pct) || (el && el.getAttribute('data-pb-sub-pct')) || 5,
        is: !!((window.PBSub && PBSub.is && PBSub.is()) || (function () { try { return localStorage.getItem('pbq_unlocked') === '1' || localStorage.getItem('pb_sub') === '1'; } catch (e) { return false; } })())
      };
    }
    function inkLib() {
      if (window.PBInk) return Promise.resolve(window.PBInk);
      return new Promise(function (res) {
        var src = shell && shell.getAttribute('data-pbs-inkjs'); if (!src) { res(null); return; }
        var sc = document.createElement('script'); sc.src = src; sc.async = true; sc.onload = function () { res(window.PBInk || null); }; sc.onerror = function () { res(null); }; document.head.appendChild(sc);
      });
    }
    function rewardShow() {
      /* shown under the matches whenever Find a bag for me lists bags (typing or Enter) */
      if (!reward || mode !== 'find') { if (reward) reward.hidden = true; return; }
      reward.hidden = false;
      if (rewardInit) return;
      rewardInit = true;
      var st = subState(), codeEl = $('[data-pbs-code]');
      var t = reward.querySelector('.pbs-reward__t'); if (t) t.textContent = 'Your ' + st.pct + '% off is ready';
      try { console.info('[pb-search] reward card shown', st.is ? '(already on the list)' : ''); } catch (e) {}
      if (st.is) { rewardReveal('exists'); return; }
      /* a plain masked code first, so the card stands even if the ink effect cannot run */
      codeEl.innerHTML = '<span class="pbs-mask" aria-hidden="true">••••••••••</span>';
      inkLib().then(function (I) {
        if (!I || rewardOpen) return;
        try { I.cover(codeEl); var m = codeEl.querySelector('.pbs-mask'); if (m && codeEl.querySelector('canvas')) m.style.visibility = 'hidden'; } catch (e) { try { console.warn('[pb-search] ink effect failed', e); } catch (x) {} }
      }).catch(function () {});
    }
    function rewardReveal(how) {
      if (rewardOpen) return; rewardOpen = true;
      /* M-F67E: the visitor's own 2 hour code first (assets/pb-sub.js); the shared code if that could not be made */
      if (window.PBSub && PBSub.ensureCode && !rewardCodeReady) { rewardCodeReady = true; rewardOpen = false; PBSub.ensureCode().then(function () { rewardReveal(how); }); return; }
      var st = subState(), codeEl = $('[data-pbs-code]'), copy = $('[data-pbs-copy]'), note = $('[data-pbs-reward-note]'), fm = $('[data-pbs-reward-form]');
      if (fm) fm.hidden = true;
      if (note) { note.hidden = how !== 'exists'; note.textContent = how === 'exists' ? "You're already on the list" : ''; }
      try { localStorage.setItem('pbq_unlocked', '1'); } catch (e) {}
      if (window.PBSub && PBSub.mark && how !== 'exists') { try { PBSub.mark('search'); } catch (e) {} }
      try { fetch('/discount/' + encodeURIComponent(st.code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {}
      codeEl.setAttribute('aria-label', 'Your code: ' + st.code);
      var mk = codeEl.querySelector('.pbs-mask'); if (mk) mk.remove();
      function showCopy() { if (copy) copy.hidden = false; }
      try { if (window.PBInk) PBInk.reveal(codeEl, st.code, showCopy); else { codeEl.textContent = st.code; showCopy(); } }
      catch (e) { codeEl.textContent = st.code; showCopy(); }
    }
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    function rewardSubmit() {
      var inp = $('[data-pbs-email]'), err = $('[data-pbs-reward-err]'), btn = $('[data-pbs-reveal]');
      var v = (inp.value || '').trim();
      if (!EMAIL_RE.test(v) || v.length > 254 || v.indexOf('..') >= 0) { err.textContent = 'Please enter a valid email address, like you@email.com.'; err.hidden = false; inp.focus(); return; }
      err.hidden = true; btn.disabled = true; btn.textContent = 'Revealing';
      if (root.hasAttribute('data-pbs-dry') || /[?&]pbs_dry=1/.test(location.search)) { root.setAttribute('data-pbs-dry', 'submitted'); setTimeout(function () { rewardReveal('ok'); }, 300); return; }
      var f = document.getElementById('pbs-sub-form');
      /* first choice: the signup service (no captcha); on any failure the hidden form below takes over */
      if (window.PBSub && PBSub.subscribe) {
        var tg = f && f.querySelector('input[name="contact[tags]"]');
        var tags = tg ? tg.value.split(',') : ['newsletter', 'bag-finder'];
        PBSub.subscribe(v, (PBSub.SRC && PBSub.SRC.searchBar) || 'src-search-bar', tags).then(function (r) {
          if (r && r.ok) { root.setAttribute('data-pbs-post', 'relay'); rewardReveal(r.existing ? 'exists' : 'ok'); return; }
          root.setAttribute('data-pbs-relay', (r && r.error) || 'failed');
          rewardForm(v, f, inp, err, btn);
        });
        return;
      }
      rewardForm(v, f, inp, err, btn);
    }
    function rewardForm(v, f, inp, err, btn) {
      var sink = document.querySelector('iframe[name="pbs-sink"]');
      if (!f || !sink) { btn.disabled = false; btn.textContent = 'Reveal my code'; err.textContent = 'Signup is not available right now. Please try again later.'; err.hidden = false; return; }
      f.querySelector('[data-pbs-sub-email]').value = v; f.setAttribute('target', 'pbs-sink');
      var done = false, timer = setTimeout(function () { if (!done) { done = true; rewardReveal('ok'); } }, 9000);
      sink.onload = function () {
        if (done) return;
        var stt = 'ok';
        try {
          var w = sink.contentWindow, href = String(w.location.href || ''), d = w.document;
          if (/\/challenge/.test(href)) stt = 'challenge';
          else if (d.querySelector('[data-pbs-posted]') || /customer_posted=true/.test(href)) stt = 'ok';
          else { var fe = d.querySelector('[data-pbs-ferr]'), msg = fe ? fe.textContent : ''; if (fe) stt = /taken|already/i.test(msg) ? 'exists' : 'error'; }
        } catch (x) { stt = 'ok'; }
        clearTimeout(timer); done = true;
        /* a captcha challenge: the signup has not happened yet. Post the form at the top level so the shopper can pass the
           challenge; back on the page, pb-topbar.js marks the signup and shows the code */
        if (stt === 'challenge') {
          try { sessionStorage.setItem('pbs_reveal', '1'); } catch (x) {}
          f.removeAttribute('target');
          var go2 = f.querySelector('[data-pbs-sub-go]'); if (go2) go2.click(); else f.submit();
          return;
        }
        if (stt === 'error') { btn.disabled = false; btn.textContent = 'Reveal my code'; err.textContent = 'That email did not go through. Please check it and try again.'; err.hidden = false; return; }
        rewardReveal(stt);
      };
      var go = f.querySelector('[data-pbs-sub-go]'); if (go) go.click(); else f.submit();
    }
    if (reward) {
      reward.addEventListener('click', function (e) {
        var t = e.target; if (!t || !t.closest) return;
        if (t.closest('[data-pbs-reveal]')) { e.preventDefault(); rewardSubmit(); return; }
        var c = t.closest('[data-pbs-copy]');
        if (c) {
          e.preventDefault();
          var code = subState().code;
          var ok = function () { c.textContent = 'Copied'; setTimeout(function () { c.textContent = 'Copy'; }, 1800); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok); else ok();
        }
      });
      reward.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-pbs-email]')) { e.preventDefault(); e.stopPropagation(); rewardSubmit(); } });
    }
    function changed() {
      show();
      clearTimeout(findT); findT = setTimeout(runFind, 300);
      if (mode === 'find') return;
      clearTimeout(timer);
      var qq = q();
      if (!qq) { lastQ = null; show(); return; }
      timer = setTimeout(function () { fetchQ(qq); }, 220);
    }
    input.addEventListener('input', function () { grow(); if (input.value.length >= lim()) say(LIMIT_MSG); changed(); });
    input.addEventListener('focus', function () { focused = true; show(); });
    if (!overlay) {
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) { focused = false; show(); } });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { focused = false; show(); } });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; grow(); changed(); input.focus(); });
    form.pbsShow = show;

    /* voice: dictation keeps listening through pauses (a fresh session after each end), stops on the tick, cancel,
       Escape, closing search, the character limit or the page going to the background. The bars show the real
       microphone level (getUserMedia -> AnalyserNode RMS, about 30 times a second, newest on the right) where the
       browser allows it next to speech recognition; on iOS, where the two fight over the microphone, recognition wins
       and the bars follow its own sound / speech / result events instead. Failures log as [pb-search voice]. */
    /* primary path: PBVoice (assets/pb-voice.js, the speech-to-text service; loaded with the panel); browser recognition
       is the fallback. The mic shows when either can run. */
    var voiceSrc = shell && shell.getAttribute('data-pbs-voicejs');
    if (voiceSrc && !window.PBVoice && !document.querySelector('script[data-pbs-voice]')) {
      var vs = document.createElement('script'); vs.src = voiceSrc; vs.defer = true; vs.setAttribute('data-pbs-voice', ''); document.head.appendChild(vs);
    }
    function canVoice() { return !!SR || !!(window.PBVoice && PBVoice.supported()); }
    if (mic && pill && !canVoice()) {
      mic.hidden = true;
      var vt = setInterval(function () { if (window.PBVoice) { clearInterval(vt); if (canVoice()) { mic.hidden = false; form.classList.add('pbs-has-mic'); } } }, 300);
      setTimeout(function () { clearInterval(vt); }, 10000);
    }
    if (mic && pill) {
      if (canVoice()) { mic.hidden = false; form.classList.add('pbs-has-mic'); }
      var IOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
      var bars = [].slice.call(pill.querySelectorAll('.pbs-voice__bars i'));
      var rec = null, state = '', orig = '', base = '', tick = 0, hist = [], est = 0, lastLen = 0, lastTap = 0, sid = 0, dog = 0;
      var stream = null, actx = null, an = null, tbuf = null, waitT = 0, restartT = 0, runs = [];
      function log(m, x) { try { console.warn('[pb-search voice] ' + m, x || ''); } catch (e) {} }
      function vis() { return bars.filter(function (b) { return b.offsetWidth > 0; }); }
      function sample() {
        var lvl;
        if (an) {
          an.getFloatTimeDomainData(tbuf);
          var sum = 0; for (var k = 0; k < tbuf.length; k++) sum += tbuf[k] * tbuf[k];
          lvl = Math.min(1, Math.pow(Math.sqrt(sum / tbuf.length) * 7, 0.75));
        } else if (extLvl !== null) { lvl = extLvl; extLvl *= 0.9; }
        else { est *= 0.86; lvl = est; }
        var vb = vis(); if (!vb.length) return;
        var prev = hist.length ? hist[hist.length - 1] : 0;
        hist.push(prev * 0.45 + lvl * 0.55); while (hist.length > vb.length) hist.shift();
        vb.forEach(function (b, i) { var h = hist[i - (vb.length - hist.length)] || 0; b.style.transform = 'scaleY(' + (0.12 + 0.88 * Math.min(1, h)).toFixed(3) + ')'; });
      }
      var extLvl = null, wv = false, wvStarting = false;   /* wv: a PBVoice session is running */
      function meterOn(ext) {
        hist = []; est = 0; extLvl = ext ? 0 : null; clearInterval(tick); tick = setInterval(sample, 33);
        if (ext) return;                                   /* PBVoice owns the microphone and reports the level */
        if (IOS || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !(window.AudioContext || window.webkitAudioContext)) return;
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
          if (state !== 'listen') { s.getTracks().forEach(function (t) { t.stop(); }); return; }
          stream = s; actx = new (window.AudioContext || window.webkitAudioContext)();
          an = actx.createAnalyser(); an.fftSize = 512; tbuf = new Float32Array(an.fftSize);
          actx.createMediaStreamSource(s).connect(an);
        }).catch(function (e) { log('level meter unavailable, using recognition events', e && e.name); });
      }
      function meterOff() {
        clearInterval(tick); tick = 0;
        if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
        if (actx && actx.close) actx.close().catch(function () {});
        stream = actx = an = tbuf = null; est = 0; hist = []; extLvl = null;
        bars.forEach(function (b) { b.style.transform = ''; });
      }
      function end(focus) {
        clearTimeout(waitT); clearTimeout(restartT); meterOff();
        pill.hidden = true; pill.classList.remove('is-wait');
        form.classList.remove('pbs-listening', 'pbs-enh'); state = '';
        drop(); show(); grow();
        if (focus) input.focus({ preventScroll: true });
      }
      function drop() {
        clearTimeout(dog);
        if (rec) {
          rec.onresult = rec.onerror = rec.onend = rec.onspeechstart = rec.onspeechend = rec.onsoundstart = rec.onsoundend = rec.onaudiostart = null;
          try { rec.abort(); } catch (e) {}
        }
        rec = null;
      }
      function finish() {
        var added = input.value !== orig; end(true);
        if (added) changed();
      }
      function setVal(v) {
        var L = lim();
        if (v.length > L) v = v.slice(0, L);
        input.value = v;
        try { input.setSelectionRange(v.length, v.length); } catch (e) {}
        grow();
        input.scrollLeft = input.scrollWidth; input.scrollTop = input.scrollHeight;   /* the newest words stay in view */
      }
      function join(a, b) { a = a.replace(/\s+$/, ''); b = b.trim(); return a && b ? a + ' ' + b : (a || b); }
      /* every start is a fresh, single-use instance (iOS will not restart one); handlers carry the session id, so a late
         onend / onerror from an older session can never restart or stop the current one */
      function session(restart) {
        drop();
        var my = ++sid;
        try { rec = new SR(); } catch (e) { log('could not create recognition', e); return false; }
        var r0 = rec;
        function live() { return my === sid && rec === r0; }
        rec.lang = root.lang && root.lang.length > 1 ? root.lang : 'en-AU';
        rec.interimResults = true; rec.continuous = true; rec.maxAlternatives = 1;
        lastLen = 0;
        rec.onresult = function (e) {
          if (!live() || state !== 'listen') return;
          var text = '';
          for (var i = 0; i < e.results.length; i++) text += e.results[i][0].transcript;
          est = Math.min(1, est + 0.3 + Math.max(0, text.length - lastLen) * 0.04); lastLen = text.length;
          var full = join(base, text);
          log('result #' + my, text.length + ' chars');
          setVal(full); show();
          if (full.length >= lim()) { say(LIMIT_MSG); state = 'done'; finish(); }
        };
        rec.onaudiostart = function () { if (!live()) return; clearTimeout(dog); est = Math.max(est, 0.08); log('audio #' + my); };
        rec.onsoundstart = function () { est = Math.max(est, 0.3); };
        rec.onspeechstart = function () { est = Math.max(est, 0.55); };
        rec.onerror = function (e) {
          log('error #' + my, e.error);
          if (!live() || state !== 'listen') return;
          var m = {
            'not-allowed': 'Allow microphone access to dictate.',
            'service-not-allowed': 'Allow microphone access to dictate.',
            'audio-capture': 'The microphone is busy or missing. Tap the mic to try again.',
            'aborted': 'Dictation stopped. Tap the mic to try again.'
          }[e.error];
          if (m) { say(m); state = 'done'; finish(); }
          /* no-speech, network: the session ends and onend starts a fresh one */
        };
        rec.onend = function () {
          log('end #' + my, live() ? state : 'stale');
          if (!live()) return;
          if (state === 'wait') { finish(); return; }
          if (state !== 'listen') return;
          if (document.visibilityState !== 'visible') { state = 'done'; finish(); return; }
          base = input.value;                       /* keep every word so far, interim ones included */
          var now = Date.now(); runs = runs.filter(function (t) { return now - t < 10000; }); runs.push(now);
          if (runs.length > 8) { say('Dictation keeps stopping. Tap the mic to try again, or type your search.'); log('too many restarts'); state = 'done'; finish(); return; }
          restartT = setTimeout(function () {
            if (!live() && sid !== my) return;
            if (state !== 'listen' || document.visibilityState !== 'visible') return;
            if (!session(true)) { say('Dictation stopped. Tap the mic to try again.'); finish(); }
          }, runs.length > 3 ? 600 : 120);
        };
        try { rec.start(); log('start #' + my, restart ? 'restart' : 'tap'); } catch (e) { log('start failed #' + my, e && (e.name || e.message)); drop(); return false; }
        /* no audio within 2.5 s: a restart the browser would not take (iOS outside a tap) ends dictation with what is in */
        dog = setTimeout(function () {
          if (!live() || state !== 'listen') return;
          log('no audio #' + my);
          if (restart) { say('Tap the mic to keep dictating.'); state = 'done'; finish(); }
        }, 2500);
        return true;
      }
      function start() {
        var now = Date.now(); if (now - lastTap < 350) return; lastTap = now;   /* one tap, one start */
        if (state === 'listen') return;
        if (state) { log('reset stale state', state); drop(); end(false); }      /* never stuck between two sessions */
        say('');
        orig = input.value; base = orig.replace(/\s+$/, ''); runs = [];
        if (base.length >= lim()) { say(LIMIT_MSG); return; }
        state = 'listen';
        /* start() runs in the tap itself (iOS needs the gesture): nothing is awaited before it */
        if (startWhisper()) { engine(true); pill.hidden = false; form.classList.add('pbs-listening'); show(); meterOn(true); return; }
        engine(false);
        if (!SR) { state = ''; say('Dictation could not start. Tap the mic to try again.'); return; }
        if (!session()) { state = ''; say('Dictation could not start. Tap the mic to try again.'); return; }
        pill.hidden = false; form.classList.add('pbs-listening'); show();
        meterOn();
      }
      /* which engine is listening: the speech-to-text service shows orange bars ("Listening, enhanced"), the browser's
         own recognition the usual blue ("Listening") */
      function engine(enhanced) {
        pill.classList.toggle('pbs-voice--enh', !!enhanced);
        form.classList.toggle('pbs-enh', !!enhanced);
        var b = pill.querySelector('.pbs-voice__bars');
        if (b) { b.setAttribute('role', 'img'); b.removeAttribute('aria-hidden'); b.setAttribute('aria-label', enhanced ? 'Listening, enhanced' : 'Listening'); }
      }
      function startWhisper() {
        if (!window.PBVoice || !PBVoice.available || !PBVoice.available()) return false;
        wvStarting = true;
        var ok = false;
        try {
          ok = PBVoice.start({
            prompt: base, noTake: IOS,
            onText: function (t) {
              if (!wv || (state !== 'listen' && state !== 'wait')) return;
              var full = join(base, t); setVal(full); show();
              if (full.length >= lim()) { say(LIMIT_MSG); state = 'wait'; PBVoice.stop(); }
            },
            onLevel: function (v) { if (wv) extLvl = Math.max(extLvl || 0, Math.min(1, v)); },
            onError: function (e) {
              log('voice service ' + (e && e.code), e && e.fallback ? 'fallback' : '');
              if (wvStarting) return;                      /* start() returns false and the tap falls through to recognition */
              if (e && e.fallback) {
                wv = false;
                if (state !== 'listen') return;
                if (IOS || !SR) { say('Tap the mic to keep going.'); state = 'done'; finish(); return; }
                base = input.value; meterOff(); engine(false); if (session()) meterOn(); else { state = 'done'; finish(); }
              } else if (e && e.message) say(e.message);
            },
            onEnd: function (i) {
              var r = i && i.reason; log('voice service end', r);
              if (!wv) return;
              wv = false;
              if (r === 'cancel') { input.value = orig; grow(); end(true); changed(); return; }
              if (r === 'stop' || r === 'timeout') { state = 'done'; finish(); return; }
              end(true);
            }
          });
        } catch (e) { log('voice service start threw', e && e.message); ok = false; }
        wvStarting = false;
        wv = !!ok;
        if (ok) log('start (voice service)');
        return wv;
      }
      mic.addEventListener('click', function (e) { e.preventDefault(); start(); });
      function cancelVoice(focus) {
        if (wv && window.PBVoice) { state = 'cancel'; PBVoice.cancel(); if (wv) { wv = false; input.value = orig; end(focus); } return; }
        state = 'cancel'; drop(); input.value = orig; end(focus);
      }
      pill.querySelector('.pbs-voice__x').addEventListener('click', function (e) {
        e.preventDefault(); cancelVoice(true); changed();
      });
      pill.querySelector('.pbs-voice__ok').addEventListener('click', function (e) {
        e.preventDefault(); if (state !== 'listen') return;
        /* voice service: the last clip is read, the final text arrives in a moment (waiting state) */
        if (wv && window.PBVoice) { state = 'wait'; pill.classList.add('is-wait'); PBVoice.stop(); return; }
        /* finish at once with the words already in the field and release the microphone (abort, fresh instance next time) */
        state = 'done'; drop(); finish();
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state) cancelVoice(false); });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'visible' && state) { if (wv) cancelVoice(false); else if (state === 'listen') { state = 'done'; finish(); } } });
      form.pbsStopVoice = function () { if (!state) return; cancelVoice(false); };
    }
    show();
  }

  function scan() { [].forEach.call(document.querySelectorAll('[data-pbs-field]'), setup); }
  /* new search fields arrive with the lazily rendered header block: react only to added nodes that hold one, so a busy
     page (countdowns, carousels) costs nothing here */
  function holds(m, sel) {
    for (var i = 0; i < m.length; i++) {
      var a = m[i].addedNodes;
      for (var k = 0; k < a.length; k++) { var n = a[k]; if (n.nodeType === 1 && (n.matches(sel) || n.querySelector(sel))) return true; }
    }
    return false;
  }
  var pend = false;
  new MutationObserver(function (m) { if (pend || !holds(m, '[data-pbs-field]')) return; pend = true; setTimeout(function () { pend = false; scan(); }, 0); })
    .observe(document.documentElement, { childList: true, subtree: true });
  scan();

  /* overlay: header row offset on open, voice stopped on close */
  /* the overlay field sits on the top bar's own row: same top and height as the pills; on desktop it is centred in the
     viewport and the pill grows into it (pbs-style reads --pbs-top / --pbs-right / --pbs-w) */
  function topOf() {
    /* the top bar measured the pill just before opening (the page lock can shift the sticky bar afterwards): keep it */
    if (+(root.getAttribute('data-pbs-placed') || 0) > Date.now() - 1500) { vv(); return; }
    var nav = document.getElementById('ab-subnav'), t = 16, bar = document.getElementById('pbt-bar');
    if (bar) {
      var ps = [].filter.call(bar.querySelectorAll('#pbt-sbtn, #pbt-menu-btn, #pbt-shop-btn'), function (e) { return e.getClientRects().length && getComputedStyle(e).display !== 'none'; });
      var sb = document.getElementById('pbt-sbtn'), wide = window.innerWidth >= 1024 && sb && sb.getClientRects().length && getComputedStyle(sb).display !== 'none';
      if (ps.length) { var r = (wide ? sb : ps[0]).getBoundingClientRect(); var v2 = Math.round(wide ? r.top : r.top + r.height / 2 - 24); if (v2 >= 0 && v2 < 200) t = v2; }
      if (wide) {
        var sr = sb.getBoundingClientRect(), vw = document.documentElement.clientWidth || window.innerWidth;
        /* desktop: the field ends centred in the viewport (field + close button), on the search pill's row */
        var W = Math.round(Math.min(706, vw - 150)) + 54;   /* field + gap + close; the field itself is centred */
        root.style.setProperty('--pbs-right', Math.round((vw - (W - 54)) / 2 - 54) + 'px');
        root.style.setProperty('--pbs-w', W + 'px');
      }
    } else if (nav) { var cs = getComputedStyle(nav); if (cs.position === 'fixed') { var v = parseFloat(cs.top); if (v >= 0 && v < 120) t = v; } }
    if (bar && window.innerWidth < 750) t = 8;   /* phones: the layer starts at the top (pbs-style adds the safe area) */
    root.style.setProperty('--pbs-top', t + 'px');
    vv();
  }
  /* keyboard open (iOS): keep the toggle and field in the visible viewport and let the panel scroll inside it */
  function vv() {
    var v = window.visualViewport; if (!v) return;
    root.style.setProperty('--pbs-vvt', Math.round(v.offsetTop) + 'px');
    root.style.setProperty('--pbs-vvh', Math.round(v.height) + 'px');
  }
  if (window.visualViewport) { visualViewport.addEventListener('resize', function () { if (root.classList.contains('pbs-open')) vv(); }); visualViewport.addEventListener('scroll', function () { if (root.classList.contains('pbs-open')) vv(); }); }
  window.pbSearchPlace = topOf;
  /* html.pbs-open follows the header search layer on every template (the header's own sync is skipped on some, e.g. the
     cart): watch the layer's class only */
  function syncOpen() {
    var l = document.querySelectorAll('#FormSearch'), o = false;
    for (var i = 0; i < l.length; i++) if (!l[i].classList.contains('popup-hidden')) { o = true; break; }
    if (o !== root.classList.contains('pbs-open')) root.classList.toggle('pbs-open', o);
  }
  var fsObs = new MutationObserver(syncOpen), fsSeen = [];
  function watchLayers() { [].forEach.call(document.querySelectorAll('#FormSearch'), function (f) { if (fsSeen.indexOf(f) === -1) { fsSeen.push(f); fsObs.observe(f, { attributes: true, attributeFilter: ['class'] }); } }); syncOpen(); }
  watchLayers();
  new MutationObserver(function (m) { if (holds(m, '#FormSearch')) watchLayers(); }).observe(document.documentElement, { childList: true, subtree: true });
  var wasOpen = root.classList.contains('pbs-open');
  new MutationObserver(function () {
    var open = root.classList.contains('pbs-open');
    if (open === wasOpen) return; wasOpen = open;
    if (open) { topOf(); try { if (window.PBVoice && PBVoice.warm) PBVoice.warm(); } catch (e) {} }
    [].forEach.call(document.querySelectorAll('#FormSearch form.pbs-form'), function (f) { if (!open && f.pbsStopVoice) f.pbsStopVoice(); if (f.pbsShow) f.pbsShow(); });
  }).observe(root, { attributes: true, attributeFilter: ['class'] });
  if (wasOpen) topOf();
  function closeOverlay() { var b = document.getElementById('SearchClose'); if (b && root.classList.contains('pbs-open')) b.click(); }
  document.addEventListener('click', function (e) { if (e.target && e.target.id === 'FormSearch') closeOverlay(); });
  /* quiz links in the search panels: search steps aside, then the quiz opens (snippets/pb-quiz handles [data-pbq-open]) */
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('#FormSearch [data-pbq-open]'); if (a && window.pbQuiz) closeOverlay(); }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeOverlay(); });
  window.addEventListener('pagehide', closeOverlay);

  /* sort menu (snippets/pbs-sort): Most popular and Trending use ?view=, the rest use sort_by */
  function closeSorts(except) {
    [].forEach.call(document.querySelectorAll('[data-pbs-sort]'), function (m) {
      if (m === except) return;
      var b = m.querySelector('.pbs-sort__btn'), l = m.querySelector('.pbs-sort__list');
      if (b) b.setAttribute('aria-expanded', 'false'); if (l) l.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var btn = t.closest('.pbs-sort__btn'), opt = t.closest('.pbs-sort__list a[data-sort]');
    if (btn) {
      var m = btn.closest('[data-pbs-sort]'), l = m.querySelector('.pbs-sort__list'), open = l.hidden;
      closeSorts(m); l.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var on = l.querySelector('a.is-on') || l.querySelector('a'); if (on) on.focus(); }
      return;
    }
    if (opt) {
      e.preventDefault();
      var v = opt.getAttribute('data-sort'), u = new URL(location.href);
      u.searchParams.delete('page'); u.searchParams.delete('section_id');
      if (v.indexOf('view:') === 0) { u.searchParams.set('view', v.slice(5)); u.searchParams.delete('sort_by'); }
      else if (v.indexOf('pb:') === 0) { u.searchParams.set('pb_sort', v.slice(3)); u.searchParams.set('sort_by', 'best-selling'); }
      else { u.searchParams.delete('view'); u.searchParams.delete('pb_sort'); u.searchParams.set('sort_by', v); }
      location.href = u.toString();
      return;
    }
    if (!t.closest('[data-pbs-sort]')) closeSorts(null);
  });
  document.addEventListener('keydown', function (e) {
    var l = e.target.closest && e.target.closest('.pbs-sort__list'); if (!l) { if (e.key === 'Escape') closeSorts(null); return; }
    var as = [].slice.call(l.querySelectorAll('a')), i = as.indexOf(e.target);
    if (e.key === 'ArrowDown') { e.preventDefault(); (as[i + 1] || as[0]).focus(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); (as[i - 1] || as[as.length - 1]).focus(); }
    else if (e.key === 'Escape') { var b = l.parentNode.querySelector('.pbs-sort__btn'); closeSorts(null); if (b) b.focus(); }
  });

  /* collections: ?pb_sort=popular|trending swaps the grid for products ordered by the rank metafield
     (up to 250, drawn from the best-selling order so large collections keep their strongest sellers) */
  function rankGrid() {
    var m = /[?&]pb_sort=(popular|trending)/.exec(location.search); if (!m) return;
    var grid = document.getElementById('items-grid'), menu = document.querySelector('[data-pbs-sort][data-mode="collection"]');
    if (!grid || !menu) return;
    var label = menu.querySelector('.pbs-sort__v');
    [].forEach.call(menu.querySelectorAll('a[data-sort]'), function (a) {
      var on = a.getAttribute('data-sort') === 'pb:' + m[1]; a.classList.toggle('is-on', on);
      a.parentNode.setAttribute('aria-selected', on ? 'true' : 'false'); if (on && label) label.textContent = a.textContent;
    });
    var form = document.getElementById('FacetFiltersForm');
    if (form && !document.querySelector('input[name="pb_sort"][form="FacetFiltersForm"]')) {
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'pb_sort'; h.value = m[1]; h.setAttribute('form', 'FacetFiltersForm'); form.parentNode.appendChild(h);
    }
    if (grid.getAttribute('data-pbs-ranked') === location.search) return;
    grid.setAttribute('data-pbs-ranked', location.search);
    var p = new URLSearchParams(location.search); p.delete('pb_sort'); p.delete('page'); p.set('sort_by', 'best-selling'); p.set('section_id', 'pbs-rank-' + m[1]);
    grid.style.opacity = '.4';
    fetch(location.pathname + '?' + p.toString()).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html'), list = d.querySelector('.pbs-ranked');
      grid.style.opacity = '';
      if (!list) { if (!grid.pbsRetry) { grid.pbsRetry = 1; grid.removeAttribute('data-pbs-ranked'); setTimeout(rankGrid, 2500); } return; }
      grid.innerHTML = list.innerHTML;
      var c = grid.closest('#ProductGridContainer') || document;
      [].forEach.call(c.querySelectorAll('.pagination, [class*="pagination"], #perpage-collection, .load-more, [x-data*="xPagination"] button'), function (el) { if (!grid.contains(el)) el.style.display = 'none'; });
    }).catch(function () { grid.style.opacity = ''; if (!grid.pbsRetry) { grid.pbsRetry = 1; grid.removeAttribute('data-pbs-ranked'); setTimeout(rankGrid, 2500); } });
  }
  rankGrid();
  var rgPend = false;
  /* only collection pages with a sort menu can need the ranked grid */
  if (document.querySelector('[data-pbs-sort][data-mode="collection"]')) new MutationObserver(function (m) { if (rgPend || !holds(m, '#items-grid, .pbs-ranked, [data-pbs-sort]') ) return; rgPend = true; setTimeout(function () { rgPend = false; rankGrid(); }, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('popstate', function () { setTimeout(rankGrid, 50); });
  window.pbSearch = { scan: scan };
})();
